module.exports = __webpack_public_path__ + "public/img/3.c8e6643b.png";